import { render, staticRenderFns } from "./ServiceSetting.vue?vue&type=template&id=7850ab4d&scoped=true&"
import script from "./ServiceSetting.vue?vue&type=script&lang=js&"
export * from "./ServiceSetting.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSetting.vue?vue&type=style&index=0&id=7850ab4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7850ab4d",
  null
  
)

export default component.exports